import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["labelInput", "dateInput", "amountInput", "categorySelect", "newEntryRow"]
  static values = {
    date: String,
    accountId: Number,
    monthId: Number,
    categories: Array
  }

  connect() {
    this.handleOutsideClick = this.handleOutsideClick.bind(this)
  }

  addEntry(event) {
    event.preventDefault()
    event.stopPropagation()

    const existingRow = document.querySelector('.new-entry-row')
    if (existingRow) {
      return
    }

    const dateHeaderRow = this.element.closest('tr')

    const newRow = document.createElement('tr')
    newRow.classList.add('entry-row', 'editing', 'new-entry-row')
    newRow.dataset.controller = 'add-checked-entry'
    newRow.dataset.addCheckedEntryDateValue = this.dateValue
    newRow.dataset.addCheckedEntryAccountIdValue = this.accountIdValue
    newRow.dataset.addCheckedEntryMonthIdValue = this.monthIdValue

    const categoryOptions = this.categoriesValue.map(cat =>
      `<option value="${cat.id}">${cat.emoji ? cat.emoji + ' ' : ''}${cat.name}</option>`
    ).join('')

    newRow.innerHTML = `
      <td>
        <input class="form-control form-control-sm" type="text" value="new entry" data-add-checked-entry-target="labelInput" data-action="keydown.enter->add-checked-entry#createEntry keydown.esc->add-checked-entry#cancel" style="display: inline-block !important;">
      </td>
      <td class="text-end entry-date">
        <input class="form-control form-control-sm" type="date" value="${this.dateValue}" data-add-checked-entry-target="dateInput" data-action="keydown.enter->add-checked-entry#createEntry keydown.esc->add-checked-entry#cancel" style="display: inline-block !important;">
      </td>
      <td class="text-end">
        <select class="form-select form-select-sm" data-add-checked-entry-target="categorySelect" data-action="keydown.enter->add-checked-entry#createEntry keydown.esc->add-checked-entry#cancel" style="display: inline-block !important;">
          <option value="">No category</option>
          ${categoryOptions}
        </select>
      </td>
      <td class="text-end">
        <input class="form-control form-control-sm" type="number" step="0.01" placeholder="0.00" data-add-checked-entry-target="amountInput" data-action="keydown.enter->add-checked-entry#createEntry keydown.esc->add-checked-entry#cancel" style="display: inline-block !important; text-align: right;">
      </td>
      <td class="text-end"></td>
    `

    dateHeaderRow.insertAdjacentElement('afterend', newRow)

    setTimeout(() => {
      const labelInput = newRow.querySelector('[data-add-checked-entry-target="labelInput"]')
      if (labelInput) {
        labelInput.focus()
        labelInput.select()
      }
      setTimeout(() => {
        document.addEventListener('click', this.handleOutsideClick, true)
      }, 100)
    }, 10)
  }

  handleOutsideClick(event) {
    const newRow = document.querySelector('.new-entry-row')
    if (!newRow) {
      document.removeEventListener('click', this.handleOutsideClick, true)
      return
    }

    if (!newRow.contains(event.target) && !event.target.closest('.new-entry-row')) {
      newRow.remove()
      document.removeEventListener('click', this.handleOutsideClick, true)
    }
  }

  createEntry(event) {
    if (!this.hasLabelInputTarget || !this.hasDateInputTarget || !this.hasAmountInputTarget || !this.hasCategorySelectTarget) {
      console.error('Missing required input targets')
      return
    }

    const label = this.labelInputTarget.value.trim()
    const date = this.dateInputTarget.value
    const amount = parseFloat(this.amountInputTarget.value)
    const categoryId = this.categorySelectTarget.value

    if (!label) {
      alert('Label is required')
      this.labelInputTarget.focus()
      return
    }

    if (!date) {
      alert('Date is required')
      this.dateInputTarget.focus()
      return
    }

    if (isNaN(amount) || amount === 0) {
      alert('Amount is required and must be non-zero')
      this.amountInputTarget.focus()
      return
    }

    const formData = new FormData()
    formData.append('finance_entry[label]', label)
    formData.append('finance_entry[checked_at]', date)
    formData.append('finance_entry[amount_cents]', amount)
    formData.append('finance_entry[account_id]', this.accountIdValue)
    formData.append('finance_entry[month_id]', this.monthIdValue)
    formData.append('finance_entry[state]', 'checked')

    if (categoryId) {
      formData.append('finance_entry[category_id]', categoryId)
    }

    fetch('/finance/entries.json', {
      method: 'POST',
      headers: {
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
      },
      body: formData
    })
    .then(response => {
      if (response.ok) {
        window.location.reload()
      } else {
        return response.json().then(errors => {
          console.error('Error creating entry:', errors)
          alert('Error creating entry. Please check the console for details.')
        })
      }
    })
    .catch(error => {
      console.error('Error creating entry:', error)
      alert('Error creating entry. Please try again.')
    })
  }

  cancel(event) {
    if (this.element.classList.contains('new-entry-row')) {
      this.element.remove()
      document.removeEventListener('click', this.handleOutsideClick, true)
    }
  }
}

